<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { Link } from '@inertiajs/vue3'
import logo from '@/../images/logo.jpg'

const isMobileMenuOpen = ref(false)
const menuRef = ref(null)

const menuItems = [
  { name: 'About',      href: '/' },
  { name: 'Programs',   href: '/' },
  { name: 'Admissions', href: '/' },
  { name: 'Contact',    href: '/' },
]

const handleClickOutside = (e) => {
  if (menuRef.value && !menuRef.value.contains(e.target))
    isMobileMenuOpen.value = false
}

onMounted(()        => document.addEventListener('click', handleClickOutside))
onBeforeUnmount(()  => document.removeEventListener('click', handleClickOutside))
</script>

<template>
  <header class="sticky top-0 z-50 bg-white/80 backdrop-blur-lg shadow-sm border-b border-gray-200">
    <div class="container mx-auto px-6 py-4 flex justify-between items-center">

      <!-- Logo -->
      <Link href="/" class="flex items-center gap-3 group">
        <img :src="logo" class="w-11 h-11 rounded-lg object-cover shadow-md transition-transform duration-300 group-hover:scale-105" />
        <div>
          <h1 class="text-lg font-bold text-primary leading-tight">Bin Mas'ud College</h1>
          <p class="text-xs text-gray-500">for Tahfiz and Islamic Studies</p>
        </div>
      </Link>

      <!-- Desktop Nav -->
      <nav class="hidden md:flex items-center gap-8">
        <Link
          v-for="item in menuItems"
          :key="item.name"
          :href="item.href"
          class="relative text-sm font-semibold text-gray-700 hover:text-primary transition-colors duration-200 group"
        >
          {{ item.name }}
          <span class="absolute left-0 -bottom-1 h-0.5 w-0 bg-primary transition-all duration-300 group-hover:w-full" />
        </Link>
      </nav>

      <!-- Desktop CTA -->
      <Link
        href="/login"
        class="hidden md:inline-flex items-center bg-green-600 hover:bg-green-700 text-white
               px-5 py-2.5 rounded-lg font-semibold text-sm shadow transition-all duration-300 hover:shadow-lg"
      >
        Log In
      </Link>

      <!-- Mobile Hamburger -->
      <button
        @click.stop="isMobileMenuOpen = !isMobileMenuOpen"
        class="md:hidden w-10 h-10 flex flex-col justify-center items-center gap-1.5"
        aria-label="Toggle menu"
      >
        <span class="block w-6 h-0.5 bg-gray-700 rounded transition-transform duration-300"
              :class="{ 'rotate-45 translate-y-2': isMobileMenuOpen }" />
        <span class="block w-6 h-0.5 bg-gray-700 rounded transition-opacity duration-300"
              :class="{ 'opacity-0': isMobileMenuOpen }" />
        <span class="block w-6 h-0.5 bg-gray-700 rounded transition-transform duration-300"
              :class="{ '-rotate-45 -translate-y-2': isMobileMenuOpen }" />
      </button>
    </div>

    <!-- Mobile Menu -->
    <transition name="fade-slide">
      <div v-if="isMobileMenuOpen" ref="menuRef"
           class="md:hidden bg-white border-t border-gray-100 shadow-lg">
        <ul class="flex flex-col gap-1 px-6 py-4">
          <li v-for="item in menuItems" :key="item.name">
            <Link
              :href="item.href"
              class="block py-2.5 text-sm font-semibold text-gray-700 hover:text-primary transition-colors"
              @click="isMobileMenuOpen = false"
            >
              {{ item.name }}
            </Link>
          </li>
          <li class="pt-2">
            <Link
              href="/login"
              class="block w-full text-center bg-primary hover:bg-primary-light text-white
                     px-5 py-2.5 rounded-lg font-semibold text-sm transition"
              @click="isMobileMenuOpen = false"
            >
              Log In
            </Link>
          </li>
        </ul>
      </div>
    </transition>
  </header>
</template>

<style scoped>
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.25s ease;
}
.fade-slide-enter-from,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}
</style>